import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ClientCoverageHistoryModel extends BaseModel {
  static urlPath = "client-coverage-history";

  @attr("json") coverageStatus;
  @attr("json") liabilityRequestStatus;
  @attr("json") liabilityStatus;
}
